import { configureStore, combineReducers } from '@reduxjs/toolkit';
import listCRPolicies from './slices/listCRPolicies';
import positions from './slices/positions';
import session from './slices/session';
import bulkUploadPositions from './slices/bulkUploadPositions';
import tableController from './slices/tableController';
import app from './slices/app';
import preHQPositions from './slices/preHQPositions';
import { preHQAPI, preHQFileUploadAPI, preHQdownloadFileApi } from '../api/preHQ';
import { loginAPI } from '../api/login';
import { downloadAPI } from '../api/download';
import { dashboardAPI } from '../api/dashboard';
import { accountAPI, accountAuthAPI } from '../api/account';
import { changeRequestPoliciesAPI } from '../api/changeRequestPolicies';
import { changeRequestsAPI } from '../api/changeRequests';
import { positionsAPI } from '../api/positions';
import { rolesAPI } from '../api/roles';
import { departmentsAPI } from '../api/departments';
import { designationsAPI } from '../api/designations';
import { locationsAPI } from '../api/locations';
import { companyAPI } from '../api/company';
import { usersAPI, usersBulkUploadAPI } from '../api/users';
import { masterAttributesAPI } from '../api/masterAttributes';
import { demandAttributesAPI } from '../api/demandAttributes';
import { commonAPI } from '../api/common';
import { recruitmentPolicyAPI } from '../api/recruitmentPolicy';

const combinedReducer = combineReducers({
    crPolicies: listCRPolicies,
    positions,
    session,
    bulkUploadPositions,
    tableController,
    app,
    preHQPositions,
    [preHQAPI.reducerPath]: preHQAPI.reducer,
    [preHQFileUploadAPI.reducerPath]: preHQFileUploadAPI.reducer,
    [preHQdownloadFileApi.reducerPath]: preHQdownloadFileApi.reducer,
    [loginAPI.reducerPath]: loginAPI.reducer,
    [downloadAPI.reducerPath]: downloadAPI.reducer,
    [dashboardAPI.reducerPath]: dashboardAPI.reducer,
    [accountAPI.reducerPath]: accountAPI.reducer,
    [accountAuthAPI.reducerPath]: accountAuthAPI.reducer,
    [changeRequestPoliciesAPI.reducerPath]: changeRequestPoliciesAPI.reducer,
    [changeRequestsAPI.reducerPath]: changeRequestsAPI.reducer,
    [positionsAPI.reducerPath]: positionsAPI.reducer,
    [rolesAPI.reducerPath]: rolesAPI.reducer,
    [departmentsAPI.reducerPath]: departmentsAPI.reducer,
    [designationsAPI.reducerPath]: designationsAPI.reducer,
    [locationsAPI.reducerPath]: locationsAPI.reducer,
    [companyAPI.reducerPath]: companyAPI.reducer,
    [usersAPI.reducerPath]: usersAPI.reducer,
    [usersBulkUploadAPI.reducerPath]: usersBulkUploadAPI.reducer,
    [masterAttributesAPI.reducerPath]: masterAttributesAPI.reducer,
    [demandAttributesAPI.reducerPath]: demandAttributesAPI.reducer,
    [commonAPI.reducerPath]: commonAPI.reducer,
    [recruitmentPolicyAPI.reducerPath]: recruitmentPolicyAPI.reducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'session/logout') {
        state = undefined;
    }
    return combinedReducer(state, action);
};

export default configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            preHQAPI.middleware,
            preHQFileUploadAPI.middleware,
            preHQdownloadFileApi.middleware,
            loginAPI.middleware,
            downloadAPI.middleware,
            dashboardAPI.middleware,
            accountAPI.middleware,
            accountAuthAPI.middleware,
            changeRequestPoliciesAPI.middleware,
            changeRequestsAPI.middleware,
            positionsAPI.middleware,
            rolesAPI.middleware,
            departmentsAPI.middleware,
            designationsAPI.middleware,
            locationsAPI.middleware,
            companyAPI.middleware,
            usersAPI.middleware,
            usersBulkUploadAPI.middleware,
            masterAttributesAPI.middleware,
            demandAttributesAPI.middleware,
            commonAPI.middleware,
            recruitmentPolicyAPI.middleware,
        ),
});
